import { globalEvents } from "@/data/Data";
import { RequestCache } from "@/data/dao/RequestCache";
import { Language } from "@/data/model/Enums";
import { CurrentIdentityService } from "@/data/services/CurrentIdentityService";
import { CurrentLocationService } from "@/data/services/CurrentLocationService";

import { changeLanguage } from "@/shared/localization/language";
import { setSharedTranslationsLanguage } from "@/shared/localization/translations";

import { i18n } from "@/portal/Trans";
import { portalEvents } from "@/portal/events/portalEvents";
import { TastierGlobal } from "@/portal/globalAccess";
import { initTranslations } from "@/portal/localization/trans";
import { PortalCurrentIdentityService } from "@/portal/services/PortalCurrentIdentityService";
import { PortalCurrentLocationService } from "@/portal/services/PortalCurrentLocationService";
import { UiNotification } from "@/portal/ui/Notification";

export class Portal {
    public static init() {
        CurrentLocationService.init(new PortalCurrentLocationService());
        CurrentIdentityService.init(new PortalCurrentIdentityService());
        if (TastierGlobal.getIdentity()) {
            changeLanguage(TastierGlobal.getLang());
            setSharedTranslationsLanguage(TastierGlobal.getLang());
        }
    }
}

initTranslations();

($.fn.datepicker as any).dates.de = {
    days: [
        i18n("enums.Weekday.Sunday"),
        i18n("enums.Weekday.Monday"),
        i18n("enums.Weekday.Tuesday"),
        i18n("enums.Weekday.Wednesday"),
        i18n("enums.Weekday.Thursday"),
        i18n("enums.Weekday.Friday"),
        i18n("enums.Weekday.Saturday"),
    ],
    daysShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
    daysMin: [
        i18n("enums.ShortWeekDay.Sunday"),
        i18n("enums.ShortWeekDay.Monday"),
        i18n("enums.ShortWeekDay.Tuesday"),
        i18n("enums.ShortWeekDay.Wednesday"),
        i18n("enums.ShortWeekDay.Thursday"),
        i18n("enums.ShortWeekDay.Friday"),
        i18n("enums.ShortWeekDay.Saturday"),
    ],
    months: [
        i18n("enums.Month.January"),
        i18n("enums.Month.February"),
        i18n("enums.Month.March"),
        i18n("enums.Month.April"),
        i18n("enums.Month.May"),
        i18n("enums.Month.June"),
        i18n("enums.Month.July"),
        i18n("enums.Month.August"),
        i18n("enums.Month.September"),
        i18n("enums.Month.October"),
        i18n("enums.Month.November"),
        i18n("enums.Month.December"),
    ],
    monthsShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    today: i18n("general.today"),
    monthsTitle: "Monate",
    clear: i18n("general.remove"),
    weekStart: 1,
    format: "dd.mm.yyyy",
};
window["jQuery"].fn["selectpicker"].defaults = { noneSelectedText: i18n("elements.select.pleaseSelect") };

const headerMenu = $("#kt_header_menu_wrapper");
if (headerMenu.length > 0) {
    const locationSwitchEl = headerMenu.find("#kt_header_menu > .locationswitch");
    console.log("Set switch");
    if (TastierGlobal.getLocationSwitch() == null) {
        TastierGlobal.setLocationSwitch(locationSwitchEl.length !== 0 ? locationSwitchEl : undefined);
        portalEvents.OnLocationChanged.dispatch(TastierGlobal.getLocationSwitch()?.getCurrentLocationId());
    }

    const prerendered = headerMenu.find("> .selectedlocation");
    if (prerendered.length !== 0) {
        const locationId = prerendered.attr("data-id");
        const lang: Language = parseInt(prerendered.attr("data-lang"));

        if (locationId !== undefined && locationId != null && !isNaN(lang)) {
            TastierGlobal.getLocationSwitch()!.setCurrentLocation(prerendered.text(), locationId, lang);
            portalEvents.OnLocationChanged.dispatch(locationId);
        }
    }

    portalEvents.OnLocationChanged.add(() => {
        RequestCache.release();
    });
}

globalEvents.OnSessionExpired.add(() => {
    UiNotification.showSessionExpired();
});

const accountPanel = $("#userpanel");
if (accountPanel.length !== 0) TastierGlobal.setAccountPanel(accountPanel);
